import request from '@/utils/request';

export function fetchList(query) {
    return request({
        url: 'https://viaglobal.pl/api//tasks',
        method: 'get',
        params: query,
    });
}

export function fetchTask(id) {
    return request({
        url: 'https://viaglobal.pl/api//tasks/' + id,
        method: 'get',
    });
}


export function createTask(data) {
    return request({
        url: 'https://viaglobal.pl/api//tasks',
        method: 'post',
        data,
    });
}

export function storeTaskComment(data) {
    return request({
        url: 'https://viaglobal.pl/api//tasks-comment',
        method: 'post',
        data,
    });
}

export function updateTask(data) {
    return request({
        url: 'https://viaglobal.pl/api//tasks/' + data.id,
        method: 'put',
        data,
    });
}

export function deleteTask(data) {
    return request({
        url: 'https://viaglobal.pl/api//tasks/' + data.id,
        method: 'delete',
        data,
    });
}


